import { c as _c } from "react/compiler-runtime";
import PublishIcon from '@mui/icons-material/Publish';
import { colors } from '../../styles/colors';
import { ButtonProps, Button } from './Button';
export const Upload: React.FC<ButtonProps> = t0 => {
  const $ = _c(5);
  const {
    onClick,
    loading
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PublishIcon />;
    t2 = {
      backgroundColor: colors.surface.interactive.default,
      color: colors.text.interactive.default
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== loading || $[3] !== onClick) {
    t3 = <Button aria-label="Upload" onClick={onClick} startIcon={t1} sx={t2} text="Upload" loading={loading} />;
    $[2] = loading;
    $[3] = onClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};